<button mat-raised-button color="primary" (click)="button()" matTooltip="Show on map">
    <mat-icon aria-label="Map">{{ icon }}</mat-icon>
</button>